import Icon from '@mdi/react';
import { mdiCookie, mdiNewspaperVariantOutline, mdiWeb } from '@mdi/js';
import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import BottomNav from '@shared/components/BottomNav';
import KundoChatButton from '@my-pages/components/KundoChatButton.tsx';
import useGetGlobalSiteSettings from '@shared/features/global-site-settings/hooks/useGetGlobalSiteSettings.ts';

const Footer = () => {
    const { t } = useTranslation();
    const isAuthenticated = useApplicationStore((state) => state.isAuthenticated);
    const { cookieInformationUrl } = useGetGlobalSiteSettings();

    return (
        <footer className='mt-auto'>
            {isAuthenticated ? (
                <>
                    <BottomNav />
                    <KundoChatButton />
                </>
            ) : (
                <div className='container-lg'>
                    <div
                        className='d-flex flex-column flex-sm-row gap-3 justify-content-between text-primary my-6 slide-down-fade-in'
                        style={{ rowGap: '1rem' }}
                    >
                        <a
                            href='https://www.transport.se'
                            className='d-flex border-0'
                            target='_blank'
                            rel='noreferrer'
                        >
                            <Icon
                                path={mdiWeb}
                                className='mdi'
                            />
                            <span
                                className='mt-1 ml-2'
                                style={{ lineHeight: '1.2' }}
                            >
                                {t('login.transportsWeb')}
                            </span>
                        </a>
                        <a
                            href='http://www.transportarbetaren.se'
                            className='d-flex border-0'
                            target='_blank'
                            rel='noreferrer'
                        >
                            <Icon
                                path={mdiNewspaperVariantOutline}
                                className='mdi'
                            />
                            <span
                                className='mt-1 ml-2'
                                style={{ lineHeight: '1.2' }}
                            >
                                {t('login.newspaperTransportarbetaren')}
                            </span>
                        </a>
                        {cookieInformationUrl ? (
                            <Link
                                to={cookieInformationUrl}
                                className='d-flex border-0'
                                title='Cookie information'
                            >
                                <Icon
                                    path={mdiCookie}
                                    className='mdi'
                                />
                                <span
                                    className='mt-1 ml-2'
                                    style={{ lineHeight: '1.2' }}
                                >
                                    Cookie information
                                </span>
                            </Link>
                        ) : null}
                    </div>
                </div>
            )}
        </footer>
    );
};

export default Footer;
